var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisai = function SvgVisai(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#192061",
    fillRule: "nonzero",
    d: "M27.22 31a10.5 10.5 0 0 1-3.83-.722l.633-2.94a7.4 7.4 0 0 0 3.495.883h.093c1.047-.015 2.1-.435 2.1-1.338.014-.576-.48-1.034-1.824-1.69-1.32-.645-3.073-1.73-3.073-3.69.003-2.65 2.42-4.5 5.886-4.5a9.4 9.4 0 0 1 3.294.6l-.617 2.94a6.6 6.6 0 0 0-2.823-.635l-.648.032c-1.016.135-1.47.666-1.47 1.133 0 .57.728.95 1.65 1.434 1.464.766 3.36 1.602 3.35 3.845C33.42 29.176 31.01 31 27.3 31zm9.744-.117h-3.705l5.28-12.6a1.6 1.6 0 0 1 1.47-1h2.94L45.8 30.88h-3.263l-.426-2.03h-4.427l-.72 2.032zm3.5-9.927-1.853 5.1h2.926zm-19.587 9.882h-3.53l2.942-13.602h3.528zm-7.72-.045H9.318L6.51 19.926c-.144-.532-.37-.97-.84-1.19a14.6 14.6 0 0 0-3.47-1.147l.09-.4h5.984a1.65 1.65 0 0 1 1.632 1.386l1.47 7.866 3.662-9.25h3.824z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisai);
export default ForwardRef;